export default __webpack_public_path__ + "static/media/InstallAppSteps.8789992e.png";